export class DownloadHelper {
  /**
   * Downloads a blob as a file with the specified filename or extracts filename from response headers
   * @param blob - The blob to download
   * @param response - The fetch response containing headers
   * @param defaultFilename - Default filename if none found in headers
   */
  static downloadBlob(blob: Blob, response: Response, defaultFilename: string = 'download.png'): void {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    
    // Extract filename from Content-Disposition header
    const disposition = response.headers.get('Content-Disposition');
    let fileName = defaultFilename;

    if (disposition && disposition.includes('filename=')) {
      const match = disposition.match(/filename="?(.+?)"?$/);
      if (match && match[1]) {
        fileName = match[1];
      }
    }
    
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  /**
   * Downloads content from a URL as a file
   * @param url - The URL to fetch
   * @param defaultFilename - Default filename if none found in headers
   */
  static async downloadFromUrl(url: string, defaultFilename: string = 'download.png'): Promise<void> {
    try {
      const response = await fetch(url);
      if (response.ok) {
        const blob = await response.blob();
        this.downloadBlob(blob, response, defaultFilename);
      } else {
        throw new Error(`Failed to download: ${response.statusText}`);
      }
    } catch (error) {
      console.error('Download error:', error);
      throw error;
    }
  }
}
